// extracted by mini-css-extract-plugin
export const visibleSmallUp = "DebtsPage__visibleSmallUp__SOwvI";